(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-details"] && !Shopify.designMode) return;
  try {
    // Composition only: content and native commerce remain in their existing owners.
  class TFPProductDetailsFlow extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = new AbortController();
      this.media = window.matchMedia('(max-width: 749px)');
      this.media.addEventListener('change', () => this.arrange(), { signal: this.controller.signal });
      this.arrange();
      const content = this.querySelector(':scope > .group-block > .group-block-content');
      if (content) {
        this.observer = new MutationObserver(() => this.arrange());
        this.observer.observe(content, { childList: true });
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }
    arrange() {
      if (this.dataset.informationMobilePosition !== 'after_purchase') return;
      const tabs = this.querySelector('tfp-product-information-tabs');
      const purchase = this.querySelector('tfp-size-purchase');
      if (!tabs || !purchase || tabs.parentElement !== purchase.parentElement) return;
      const parent = purchase.parentElement;
      // The marker preserves the actual Editor/template position on desktop.
      if (!this.origin || this.origin.parentNode !== parent) {
        this.origin = document.createComment('Product information template position');
        parent.insertBefore(this.origin, tabs);
      }
      const reference = this.media.matches ? purchase.nextSibling : this.origin.nextSibling;
      if (reference === tabs) return;
      const focused = tabs.contains(document.activeElement) ? document.activeElement : null;
      if (typeof parent.moveBefore === 'function') parent.moveBefore(tabs, reference);
      else parent.insertBefore(tabs, reference);
      focused?.focus({ preventScroll: true });
    }
  }
  if (!customElements.get('tfp-product-details-flow')) customElements.define('tfp-product-details-flow', TFPProductDetailsFlow);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["tfp-product-card-sizes"] && !Shopify.designMode) return;
  try {
    let tfpCardSizesRuntime;
  const tfpCardSizesPending = new WeakSet();

  function loadTFPCardSizes(host) {
    if (customElements.get('product-card-sizes')) return Promise.resolve();
    if (!tfpCardSizesRuntime) {
      tfpCardSizesRuntime = import(host.dataset.sizesRuntime).then(() => {
        if (!customElements.get('product-card-sizes')) throw new Error('Card sizes runtime unavailable');
      }).catch((error) => {
        tfpCardSizesRuntime = undefined;
        throw error;
      });
    }
    return tfpCardSizesRuntime;
  }

  async function openTFPCardSizes(event) {
    if (!(event.target instanceof Element)) return;
    const trigger = event.target.closest('[data-card-sizes-trigger]');
    const host = trigger?.closest('product-card-sizes');
    if (!(trigger instanceof HTMLButtonElement) || !(host instanceof HTMLElement)) return;
    if (customElements.get('product-card-sizes')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (tfpCardSizesPending.has(host)) return;
    tfpCardSizesPending.add(host);
    host.removeAttribute('data-sizes-runtime-error');
    trigger.disabled = true;
    host.setAttribute('aria-busy', 'true');
    try {
      await loadTFPCardSizes(host);
      if (!host.isConnected || !host.contains(trigger)) return;
      customElements.upgrade(host);
      await host.expand();
    } catch (error) {
      if (host.isConnected) {
        host.setAttribute('data-sizes-runtime-error', '');
        const status = host.querySelector('[data-card-sizes-status]');
        if (status instanceof HTMLElement) {
          status.textContent = host.dataset.statusError;
          status.hidden = false;
        }
      }
      console.warn('[tfp-product-card-sizes] Runtime unavailable:', error);
    } finally {
      tfpCardSizesPending.delete(host);
      trigger.disabled = false;
      host.removeAttribute('aria-busy');
    }
  }

  function autoLoadTFPCardSizes(event) {
    const host = event.target;
    if (!(host instanceof HTMLElement) || !host.matches('product-card-sizes[data-auto-open]')) return;
    void loadTFPCardSizes(host).catch((error) => {
      if (host.isConnected) {
        host.setAttribute('data-sizes-runtime-error', '');
        const status = host.querySelector('[data-card-sizes-status]');
        if (status instanceof HTMLElement) {
          status.textContent = host.dataset.statusError;
          status.hidden = false;
        }
      }
      console.warn('[tfp-product-card-sizes] Automatic runtime unavailable:', error);
    });
  }

  document.addEventListener('click', openTFPCardSizes, true);
  document.addEventListener('tfp:card-sizes-auto-open', autoLoadTFPCardSizes);
  document.documentElement.setAttribute('data-tfp-card-sizes-loader', '');
  const pendingSingleSizes = document.querySelector('product-card-sizes[data-auto-open]');
  if (pendingSingleSizes instanceof HTMLElement) {
    autoLoadTFPCardSizes({ target: pendingSingleSizes });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["tfp-product-information-tabs"] && !Shopify.designMode) return;
  try {
    // Only bootstrap globally; the tab controller belongs to the rendered owner.
  let runtime;
  const load = host => {
    if (!host || customElements.get('tfp-product-information-tabs')) return;
    runtime ||= import(host.dataset.informationRuntime).catch(error => {
      runtime = undefined;
      throw error;
    });
    void runtime.then(() => observer?.disconnect()).catch(() => {
      // Native anchor/hash panels remain usable; later intent retries the import.
    });
  };
  const ownerFor = target => {
    if (!(target instanceof Element)) return null;
    return target.closest('tfp-product-information-tabs') ||
      (target.closest('[data-tfp-reviews-tab-link]') &&
       target.closest('.shopify-section')?.querySelector('tfp-product-information-tabs'));
  };
  document.addEventListener('pointerdown', event => load(ownerFor(event.target)), { capture: true, passive: true });
  document.addEventListener('focusin', event => load(ownerFor(event.target)), true);
  // Never swallow the first click: native hashes handle clicks while downloading.
  document.addEventListener('click', event => load(ownerFor(event.target)), true);
  let observer;
  const arm = () => {
    const hosts = document.querySelectorAll('tfp-product-information-tabs:not(:defined)');
    for (const host of hosts) {
      if (window.Shopify?.designMode || !('IntersectionObserver' in window) ||
          (window.location.hash && host.querySelector(`[id="${CSS.escape(window.location.hash.slice(1))}"]`))) {
        load(host);
      } else {
        observer ||= new IntersectionObserver(entries => {
          for (const entry of entries) if (entry.isIntersecting) load(entry.target);
        }, { rootMargin: '0px' });
        observer.observe(host);
      }
    }
  };
  arm();
  document.addEventListener('shopify:section:load', arm);
  document.addEventListener('shopify:section:unload', event => {
    for (const host of event.target.querySelectorAll('tfp-product-information-tabs')) observer?.unobserve(host);
  });
  window.addEventListener('hashchange', () => load(ownerFor(document.querySelector(':target'))));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["tfp-product-proof-highlights"] && !Shopify.designMode) return;
  try {
    class TFPProductProofs extends HTMLElement {
    connectedCallback() {
      if (this.dataset.proofsReady === 'true') return;

      this.lifecycleGeneration = (this.lifecycleGeneration || 0) + 1;
      this.dataset.proofsReady = 'true';
      this.railCleanups = [];
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.addEventListener('click', this.onClick);

      this.querySelectorAll('.tfp-product-proof-rail').forEach((rail) => {
        delete rail.dataset.progressReady;
        this.setupRail(rail);
      });
      this.querySelectorAll('details.tfp-product-proof-card[open]').forEach((details) => {
        this.hydrate(details);
      });
    }

    disconnectedCallback() {
      this.lifecycleGeneration = (this.lifecycleGeneration || 0) + 1;
      this.removeEventListener('click', this.onClick);
      this.railCleanups?.forEach((cleanup) => cleanup());
      this.railCleanups = [];
      this.querySelectorAll('.tfp-product-proof-card__content').forEach((content) => {
        content.getAnimations().forEach((animation) => animation.cancel());
        content.querySelector('.tfp-product-proof-rail')?.getAnimations().forEach((animation) => animation.cancel());
        content.style.removeProperty('height');
        content.style.removeProperty('overflow');
        content.closest('details')?.removeAttribute('data-animating');
      });
      delete this.dataset.proofsReady;
    }

    onClick = (event) => {
      if (!(event.target instanceof Element)) return;

      const directionButton = event.target.closest('button[data-proof-direction]');
      if (directionButton && this.contains(directionButton)) {
        const rail = directionButton.closest('.tfp-product-proof-rail-shell')?.querySelector('.tfp-product-proof-rail');
        const slides = rail?.querySelectorAll('.tfp-product-proof-slide');
        if (!rail || !slides?.length) return;

        const positions = [...slides].map((slide) => slide.offsetLeft - slides[0].offsetLeft);
        const current = rail.scrollLeft;
        const maxScroll = Math.max(0, rail.scrollWidth - rail.clientWidth);
        const forward = Number(directionButton.dataset.proofDirection) > 0;
        const target = forward
          ? positions.find((position) => position > current + 2) ?? maxScroll
          : positions.findLast((position) => position < current - 2) ?? 0;
        rail.scrollTo({
          left: Math.min(maxScroll, Math.max(0, target)),
          behavior: this.reducedMotion.matches ? 'auto' : 'smooth'
        });
        return;
      }

      const summary = event.target.closest('summary.tfp-product-proof-card__summary');
      if (!summary || !this.contains(summary)) return;

      const details = summary.parentElement;
      if (!(details instanceof HTMLDetailsElement)) return;

      event.preventDefault();

      if (details.dataset.animating === 'true') return;

      if (details.open) {
        this.close(details);
      } else {
        this.open(details);
      }
    };

    open(details) {
      if (this.dataset.singleOpen === 'true') {
        this.querySelectorAll('details.tfp-product-proof-card[open]').forEach((other) => {
          if (other !== details) this.close(other);
        });
      }

      this.hydrate(details);

      const content = details.querySelector(':scope > .tfp-product-proof-card__content');
      if (!content) {
        details.open = true;
        return;
      }

      if (this.reducedMotion.matches) {
        details.open = true;
        return;
      }

      details.dataset.animating = 'true';
      content.getAnimations().forEach((animation) => animation.cancel());

      content.style.height = '0px';
      content.style.overflow = 'clip';
      details.open = true;

      const generation = this.lifecycleGeneration;
      requestAnimationFrame(() => {
        if (!this.isConnected || generation !== this.lifecycleGeneration) return;
        const endHeight = content.scrollHeight;
        const rail = content.querySelector('.tfp-product-proof-rail');

        const expand = content.animate(
          [
            { height: '0px' },
            { height: endHeight + 'px' }
          ],
          {
            duration: 240,
            easing: 'cubic-bezier(0, 0, 0.4, 1)'
          }
        );

        const reveal = rail?.animate(
          [
            { opacity: 0, transform: 'translate3d(0, 4px, 0)' },
            { opacity: 1, transform: 'translate3d(0, 0, 0)' }
          ],
          {
            duration: 190,
            delay: 34,
            easing: 'cubic-bezier(0, 0, 0.4, 1)',
            fill: 'both'
          }
        );

        expand.addEventListener('finish', () => {
          content.style.removeProperty('height');
          content.style.removeProperty('overflow');
          details.dataset.animating = 'false';
        }, { once: true });

        reveal?.addEventListener('finish', () => reveal.cancel(), { once: true });
      });
    }

    close(details) {
      const content = details.querySelector(':scope > .tfp-product-proof-card__content');

      if (!content || this.reducedMotion.matches) {
        details.open = false;
        return;
      }

      details.dataset.animating = 'true';
      content.getAnimations().forEach((animation) => animation.cancel());

      const rail = content.querySelector('.tfp-product-proof-rail');
      const startHeight = content.getBoundingClientRect().height;

      content.style.height = startHeight + 'px';
      content.style.overflow = 'clip';

      rail?.animate(
        [
          { opacity: 1, transform: 'translate3d(0, 0, 0)' },
          { opacity: 0.45, transform: 'translate3d(0, 2px, 0)' }
        ],
        {
          duration: 130,
          easing: 'cubic-bezier(0.5, 0, 1, 1)',
          fill: 'both'
        }
      );

      const collapse = content.animate(
        [
          { height: startHeight + 'px' },
          { height: '0px' }
        ],
        {
          duration: 180,
          easing: 'cubic-bezier(0.5, 0, 1, 1)'
        }
      );

      collapse.addEventListener('finish', () => {
        details.open = false;
        content.style.removeProperty('height');
        content.style.removeProperty('overflow');
        details.dataset.animating = 'false';
      }, { once: true });
    }

    hydrate(details) {
      const target = details.querySelector(':scope > .tfp-product-proof-card__content');
      const template = details.querySelector(':scope > template[data-proof-template]');

      if (!target || !template || target.dataset.hydrated === 'true') return;

      target.append(template.content.cloneNode(true));
      target.dataset.hydrated = 'true';

      const rail = target.querySelector('.tfp-product-proof-rail');
      if (rail) this.setupRail(rail);

      target.querySelectorAll('.tfp-product-proof-slide__image').forEach((image) => {
        const reveal = () => {
          image.dataset.loaded = 'true';
        };

        const decodeAndReveal = () => {
          if (typeof image.decode === 'function') {
            image.decode().then(reveal).catch(reveal);
          } else {
            reveal();
          }
        };

        if (image.complete) {
          decodeAndReveal();
        } else {
          image.addEventListener('load', decodeAndReveal, { once: true });
          image.addEventListener('error', reveal, { once: true });
        }
      });
    }

    setupRail(rail) {
      if (rail.dataset.progressReady === 'true') return;

      rail.dataset.progressReady = 'true';
      const shell = rail.closest('.tfp-product-proof-rail-shell');
      if (!shell) return;
      const previous = shell.querySelector('[data-proof-direction="-1"]');
      const next = shell.querySelector('[data-proof-direction="1"]');

      let frame = 0;

      const update = () => {
        frame = 0;

        const maxScroll = Math.max(0, rail.scrollWidth - rail.clientWidth);
        const progress = maxScroll > 0 ? Math.min(1, Math.max(0, rail.scrollLeft / maxScroll)) : 1;
        const visibleProgress = 0.14 + progress * 0.86;

        shell.style.setProperty('--proof-progress', visibleProgress.toFixed(4));
        shell.dataset.hasOverflow = maxScroll > 2 ? 'true' : 'false';
        if (previous instanceof HTMLButtonElement) previous.disabled = maxScroll <= 2 || rail.scrollLeft <= 2;
        if (next instanceof HTMLButtonElement) next.disabled = maxScroll <= 2 || rail.scrollLeft >= maxScroll - 2;
      };

      const onScroll = () => {
        if (frame) return;
        frame = requestAnimationFrame(update);
      };
      rail.addEventListener('scroll', onScroll, { passive: true });

      const resizeObserver = new ResizeObserver(() => {
        if (frame) return;
        frame = requestAnimationFrame(update);
      });
      resizeObserver.observe(rail);

      frame = requestAnimationFrame(update);
      this.railCleanups.push(() => {
        rail.removeEventListener('scroll', onScroll);
        resizeObserver.disconnect();
        if (frame) cancelAnimationFrame(frame);
        delete rail.dataset.progressReady;
      });
    }
  }

  if (!customElements.get('tfp-product-proofs')) {
    customElements.define('tfp-product-proofs', TFPProductProofs);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["tfp-size-purchase"] && !Shopify.designMode) return;
  try {
    class TFPSizePurchase extends HTMLElement {
    connectedCallback() {
      if (this.purchaseZoneReady) return;
      this.purchaseZoneReady = true;
      this.addEventListener('tfp:pdp-size-selected', this.onSizeSelected);
      this.addEventListener('change', this.onVariantChange);
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKeyDown);
      requestAnimationFrame(() => {
        if (this.isConnected) this.syncSelectedSize();
      });
    }

    disconnectedCallback() {
      this.purchaseZoneReady = false;
      this.removeEventListener('tfp:pdp-size-selected', this.onSizeSelected);
      this.removeEventListener('change', this.onVariantChange);
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKeyDown);
    }

    normalizeSize(value) {
      return String(value || '').trim().replace(',', '.').toLocaleLowerCase(document.documentElement.lang || undefined);
    }

    sizeInputs() {
      return Array.from(this.querySelectorAll('variant-picker input[data-option-name]')).filter((input) => {
        if (!(input instanceof HTMLInputElement)) return false;
        const name = (input.dataset.optionName || '').toLocaleLowerCase(document.documentElement.lang || undefined);
        return name.includes('size') || name.includes('μέγεθ') || name.includes('νούμερ');
      });
    }

    matchingSizeInput(value) {
      const target = this.normalizeSize(value);
      return this.sizeInputs().find((input) =>
        this.normalizeSize(input.value) === target || this.normalizeSize(input.dataset.displayValue) === target
      ) || null;
    }

    syncSelectedSize(value) {
      const checked = value || this.sizeInputs().find((input) => input.checked)?.value || '';
      for (const button of this.querySelectorAll('[data-size-guide-select-size]')) {
        if (button instanceof HTMLButtonElement) {
          button.setAttribute('aria-pressed', this.normalizeSize(button.dataset.sizeGuideSelectSize) === this.normalizeSize(checked) ? 'true' : 'false');
        }
      }
    }

    onSizeSelected = (event) => {
      if (!(event instanceof CustomEvent) || !(event.target instanceof Element) || !this.contains(event.target)) return;
      this.dataset.purchaseReady = event.detail?.available !== false ? 'true' : 'false';
      this.syncSelectedSize(event.detail?.value);
    };

    onVariantChange = (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || !this.sizeInputs().includes(input)) return;
      this.dataset.purchaseReady = input.dataset.optionAvailable === 'true' ? 'true' : 'false';
      requestAnimationFrame(() => {
        if (this.isConnected) this.syncSelectedSize(input.value);
      });
    };

    onKeyDown = (event) => {
      if (event.key !== 'Enter' || !(event.target instanceof HTMLElement) || !event.target.matches('[data-size-finder-input]')) return;
      event.preventDefault();
      this.runSizeFinder(event.target.closest('[data-size-finder]'));
    };

    onClick = (event) => {
      if (!(event.target instanceof Element)) return;
      const submit = event.target.closest('[data-size-finder-submit]');
      if (submit instanceof HTMLButtonElement && this.contains(submit)) {
        this.runSizeFinder(submit.closest('[data-size-finder]'));
        return;
      }

      const button = event.target.closest('[data-size-guide-select-size]');
      if (!(button instanceof HTMLButtonElement) || !this.contains(button)) return;
      const input = this.matchingSizeInput(button.dataset.sizeGuideSelectSize);
      if (!(input instanceof HTMLInputElement)) return;
      event.preventDefault();
      event.stopPropagation();
      if (!input.checked) input.click();
      this.syncSelectedSize(input.value);
      const drawer = button.closest('theme-drawer');
      if (drawer && typeof drawer.close === 'function') void drawer.close();
    };

    adjacentAvailableSize(baseSize, direction) {
      const choices = this.sizeInputs()
        .map((input) => ({ input, number: Number(this.normalizeSize(input.value)) }))
        .filter((choice) => Number.isFinite(choice.number))
        .sort((a, b) => a.number - b.number);
      const baseIndex = choices.findIndex((choice) => choice.number === Number(baseSize));
      if (baseIndex < 0) return null;
      const adjacent = choices[baseIndex + direction];
      if (!adjacent || adjacent.input.dataset.optionAvailable !== 'true') return null;
      return adjacent.input.value;
    }

    formatMessage(template, values = {}) {
      return Object.entries(values).reduce((message, [key, value]) =>
        message.replaceAll(`{${key}}`, String(value)), String(template || ''));
    }

    runSizeFinder(finder) {
      const input = finder?.querySelector('[data-size-finder-input]');
      const status = finder?.querySelector('[data-size-finder-status]');
      if (!(input instanceof HTMLInputElement) || !(status instanceof HTMLElement)) return;
      const measurement = Number.parseFloat(input.value.replace(',', '.'));
      const rows = Array.from(this.querySelectorAll('[data-size-finder-row]'))
        .map((row) => ({
          row,
          length: Number.parseFloat(String(row.dataset.footLength || '').replace(',', '.')),
          size: String(row.dataset.euSize || '').trim(),
        }))
        .filter((item) => Number.isFinite(item.length) && item.size);
      if (!Number.isFinite(measurement) || !rows.length) {
        status.textContent = finder.dataset.msgInvalid || '';
        return;
      }
      const lengths = rows.map((item) => item.length);
      const min = Math.min(...lengths);
      const max = Math.max(...lengths);
      if (measurement < min || measurement > max) {
        status.textContent = this.formatMessage(finder.dataset.msgRange, { min: min.toFixed(1), max: max.toFixed(1) });
        return;
      }

      rows.sort((a, b) => Math.abs(a.length - measurement) - Math.abs(b.length - measurement));
      const match = rows[0];
      for (const row of rows) row.row.removeAttribute('data-size-finder-match');
      match.row.setAttribute('data-size-finder-match', 'true');

      const mode = this.dataset.fitAdviceMode;
      const direction = mode === 'runs_small_size_up' || mode === 'fits_slightly_small' ? 1
        : mode === 'runs_large_size_down' || mode === 'fits_slightly_large' ? -1 : 0;
      const adjusted = direction ? this.adjacentAvailableSize(match.size, direction) : null;
      const base = this.formatMessage(finder.dataset.msgBase, { size: match.size, length: match.length.toFixed(1) });
      let fit = '';
      if (direction && adjusted) {
        fit = this.formatMessage(finder.dataset.msgAdjusted, { size: adjusted });
      } else if (direction) {
        fit = finder.dataset.msgNoAdjacent || '';
      }
      status.textContent = [base, fit, finder.dataset.msgDisclaimer].filter(Boolean).join(' ');

      const focusSize = adjusted || match.size;
      const sizeButton = Array.from(this.querySelectorAll('[data-size-guide-select-size]'))
        .find((button) => this.normalizeSize(button.dataset.sizeGuideSelectSize) === this.normalizeSize(focusSize));
      if (sizeButton instanceof HTMLButtonElement) {
        sizeButton.focus({ preventScroll: true });
        sizeButton.scrollIntoView({ block: 'nearest', inline: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
    }
  }

  if (!customElements.get('tfp-size-purchase')) customElements.define('tfp-size-purchase', TFPSizePurchase);
  } catch(e) { console.error(e); }
})();

})();
